import { View } from "binder"
import { PersonnelSearchViewModel } from "src/erp/enterpriseAdministration/humanResource/personnel/personnelSearch/personnelSearch-viewModel";
import { UserEditorViewModel } from "./userEditor-viewModel"

export class UserEditorView extends View<UserEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-A2504D0A-67ED-4A17-998E-82267727B819"
    }
    loadHtml(): string {
        let element = require('./userEditor.html').default;
        let style = require('./userEditor.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set username(v: string) { this._username = v; } public get username(): string { return this._username;} private _username: string;
    public set password(v: string) { this._password = v; } public get password(): string { return this._password;} private _password: string;
    public set repeatPassword(v: string) { this._repeatPassword = v; } public get repeatPassword(): string { return this._repeatPassword;} private _repeatPassword: string;
    public set personnelSelector(v: PersonnelSearchViewModel) { this._personnelSelector = v; } public get personnelSelector(): PersonnelSearchViewModel { return this._personnelSelector;} private _personnelSelector: PersonnelSearchViewModel;
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName;} private _personnelName: string;
    public set personnelCode(v: string) { this._personnelCode = v; } public get personnelCode(): string { return this._personnelCode;} private _personnelCode: string;

    
    back(){
        this.dataContext.back();
    }

    save(){
        this.dataContext.save();
    }
}
